import { render } from "./PostList.vue?vue&type=template&id=16a29265&scoped=true"
import script from "./PostList.vue?vue&type=script&lang=js"
export * from "./PostList.vue?vue&type=script&lang=js"

import "./PostList.vue?vue&type=style&index=0&id=16a29265&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16a29265"]])

export default __exports__